import React from 'react';

export type DividerProps = {
  hideLine?: boolean;
  children?: string;
  center?: boolean;
  overlapLine?: boolean;
  xsFont?: boolean;
  className?: string;
};

const Divider: React.FC<DividerProps> = ({
  children: label,
  hideLine = false,
  center = false,
  overlapLine = false,
  xsFont = false,
  className = '',
}: DividerProps) => {
  let containerClass = 'pt-1 pb-1';
  if (center) {
    containerClass += ' text-center';
  }
  let labelClass = 'font-medium ml-2';
  labelClass += xsFont ? ' text-xs' : ' text-sm';
  if (overlapLine) {
    labelClass += ' relative px-2';
  }
  return (
    <div className={`${className} ${containerClass}`}>
      {!hideLine && <hr className="mb-1" />}
      {label && (
        <span
          className={labelClass}
          style={overlapLine ? { top: '-17px' } : undefined}
        >
          {label}
        </span>
      )}
    </div>
  );
};
export default Divider;
